	<article id="rules" class="rules" [ngClass]="{'active': CampSvc.currentState == 'rules', 'inactive': CampSvc.currentState != 'rules'}" *ngIf="CS.sweeps_active">
	<div>
		<div class="article">
			<div class="shell shell--large">
				<div class="article__inner">
					<div class="article__actions">
						<a (click)="closeSection()" class="btn">Go Back</a>
					</div><!-- /.article__actions -->
				</div><!-- /.article__inner -->
				<div class="article__head">
					<h1 class="h2">Official Rules</h1><!-- /.h2 -->
				</div><!-- /.article__head -->

				<div class="article__body js-container simplebar">
					<span [innerHTML]="CS.rules_copy"></span>
					<div class="article__actions">
						<a (click)="closeSection()" class="btn">Go Back</a>
					</div><!-- /.article__actions -->
				</div><!-- /.article__inner -->
			</div><!-- /.shell -->
		</div><!-- /.article -->
		</div>	
	</article><!-- /.section-alt rules non-sweeps-->
	
	<article id="privacy" class="privacy " [ngClass]="{'active': CampSvc.currentState == 'privacy', 'inactive': CampSvc.currentState != 'privacy'}" >
		<!--<div ng-include="'views/partials/privacy.html'"></div>-->
		<div><app-privacy></app-privacy></div>
	</article><!-- /.section-alt rules non-sweeps-->
	
	<article id="terms" class="terms " [ngClass]="{'active': CampSvc.currentState == 'terms', 'inactive': CampSvc.currentState != 'terms'}" >
		<!--<div ng-include="'views/partials/terms.html'"></div>-->
		<app-terms></app-terms>
	</article><!-- /.section-alt rules non-sweeps-->



<footer class="footer">
	<div class="shell">
		<div class="footer__nav">
			<ul>
				<li>
					<a (click)="openSection('privacy')"  analytics-on="click" analytics-event='clicked on privacy'>Privacy Policy</a>
				</li><!--href="{{CS.site_content.rules_file_name}}"-->
				<li *ngIf="CS.sweeps_active">
					<a (click)="openSection('rules')" 
					target="_blank"
					analytics-on="click"
					analytics-event="Clicked on Official Rules Link" class="footer_rules">Official Rules </a>
				</li>
				<li>
					<a (click)="openSection('terms')"  analytics-on="click" analytics-event='clicked on terms'>Terms of Service</a>
					<!--ng-click="toggleModal('privacy')"-->
				</li>
			</ul>
			<p [innerHTML]="CS.footer_copy"></p>
			<!--<p class="abbrev" ng-show="CS.sweeps_active" ng-bind-html="CS.site_content.abbreviated_rules"></p>
			<p class="footer__copyright">&copy; 2021, STARZ All rights reserved. Vida © 2020 Starz Entertainment, LLC. All rights reserved. Luther. Men In Kilts: A Roadtrip with Sam and Graham © 2021 Sony Pictures Television Inc. All rights reserved. The Luminaries © WTTV Ltd 2019. All rights reserved. American Gods © 2020 FremantleMedia North America, Inc. All rights reserved. Ruth – Justice Ginsburg In Her Own Words © 2020 American Film Foundation/Sanders & Mock Productions. All rights reserved. Bloodshot ©2020 Columbia Pictures Industries, Inc. and Bona Film Investment Company (Pacific Rim, USA) and Cross Creek Pictures. All Rights Reserved. Men In Black 3 © 2012 Columbia Pictures Industries, Inc. All Rights Reserved. Jumanji: The Next Level © 2019 Columbia Pictures Industries, Inc. Bad Boys For Life © 2020 Columbia Pictures Industries, Inc. and 2.0 Entertainment. All Rights Reserved. A Beautiful Day in the Neighborhood © 2019 Columbia Pictures Industries, Inc. and Tencent Pictures (USA) LLC. Charlie’s Angels™ © 2019 Columbia Pictures Industries, Inc., and Perfect World Pictures and 2.0 Entertainment. Elf © 2003 New Line Productions, Inc. Fantasy Island © 2020 Columbia Pictures Industries, Inc and Blumhouse Productions, LLC. The Intruder © 2019 Motivated Seller LLC. Little Women © 2019 Columbia Pictures Industries, Inc. and Monarchy Enterprises S.àr.l. and Regency Entertainment (USA), Inc. Once Upon a Time…in Hollywood © 2019 Visiona Romantica, Inc. Hightown © 2020 Starz Entertainment, LLC. All rights reserved. Power © 2020 Starz Entertainment, LLC. All rights reserved Power Book II: Ghost © MMXX Lions Gate Television, Inc. All Rights Reserved. The Spanish Princess © 2020 TSP2 Productions Ltd. All rights reserved. Seduced: Inside the NXIVM Cult © MMXX Lions Gate Television Inc. All rights reserved Spider-ManTM: Far From Home © 2019 Columbia Pictures Industries, Inc. All Rights Reserved. MARVEL and all related character names: © & TM 2019 MARVEL. The Breakfast Club © 1984 Universal City Studios, Inc. and Dino De Laurentiis Corporation. All Rights Reserved. Meet the Parents © 2000 Universal Studios and Dreamworks, LLC. Mamma Mia © 2008 Universal Studios.
</p>-->
			
		</div><!-- /.footer__nav -->
	</div><!-- /.shell -->
</footer><!-- /.footer -->